module.exports = __webpack_public_path__ + "static/img/1_3_1.cb259888.jpg";